module["exports"] = [
  "#{city_prefix}#{city_suffix}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/address/city.js
 ** module id = 983
 ** module chunks = 0
 **/